import React from 'react';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, MessageCircle, Star } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-[#0B0B15] text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo and description */}
          <div>
            <img
              src="/logo.png"
              alt="Diversytoys"
              className="h-16 mb-4"
            />
            <p className="text-gray-400 font-quicksand mb-6">
              Desde 2007, llevamos alegría a tu hogar con los mejores juguetes para cada etapa del crecimiento.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=100063210100576" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#1A1A2E] flex items-center justify-center hover:bg-[#1877F2] hover:-translate-y-1 transition-all duration-300" title="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/jugueteria_diversytoys/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#1A1A2E] flex items-center justify-center hover:bg-[#E1306C] hover:-translate-y-1 transition-all duration-300" title="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://wa.me/573146758677" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#1A1A2E] flex items-center justify-center hover:bg-[#25D366] hover:-translate-y-1 transition-all duration-300" title="WhatsApp">
                <MessageCircle size={20} />
              </a>
              <a href="https://www.google.com/maps/place/Jugueter%C3%ADa+DIVERSYTOYS/@6.1534721,-75.3749534,17z/data=!3m1!4b1!4m6!3m5!1s0x8e469fa08aae6d1b:0x912abb9aa8437bc7!8m2!3d6.1534668!4d-75.3723785!16s%2Fg%2F11xsgbhm7f?entry=ttu&g_ep=EgoyMDI2MDQyNi4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[#1A1A2E] flex items-center justify-center hover:bg-[#F4B400] hover:-translate-y-1 transition-all duration-300" title="Google Maps">
                <Star size={20} />
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="text-[#FFD700] font-fredoka font-bold text-lg mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2 font-quicksand">
              <li>
                <Link to="/" className="hover:text-[#00C2CB] transition-colors" data-testid="footer-link-home">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-[#00C2CB] transition-colors" data-testid="footer-link-products">
                  Productos
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-[#00C2CB] transition-colors" data-testid="footer-link-about">
                  Acerca de
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#00C2CB] transition-colors" data-testid="footer-link-contact">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h3 className="text-[#FFD700] font-fredoka font-bold text-lg mb-4">Contacto</h3>
            <ul className="space-y-3 font-quicksand">
              <li className="flex items-start">
                <Phone className="w-5 h-5 mr-3 mt-1 text-[#00C2CB]" />
                <span>314 675 8677</span>
              </li>
              <li className="flex items-start">
                <Mail className="w-5 h-5 mr-3 mt-1 text-[#00C2CB]" />
                <span>info@diversytoys.com</span>
              </li>
              <li className="flex items-start">
                <MapPin className="w-5 h-5 mr-3 mt-1 text-[#00C2CB] shrink-0" />
                <a href="https://www.google.com/maps/place/Jugueter%C3%ADa+DIVERSYTOYS/@6.1534721,-75.3749534,17z/data=!3m1!4b1!4m6!3m5!1s0x8e469fa08aae6d1b:0x912abb9aa8437bc7!8m2!3d6.1534668!4d-75.3723785!16s%2Fg%2F11xsgbhm7f?entry=ttu&g_ep=EgoyMDI2MDQyNi4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="hover:text-[#00C2CB] transition-colors">
                  Cra 48 # 49-21 Local 113 CC Colonial / Rionegro - Ant
                </a>
              </li>
              <li className="flex items-start">
                <Clock className="w-5 h-5 mr-3 mt-1 text-[#00C2CB]" />
                <span>Lun - Vie: 9:00 AM - 7:30 PM</span>
              </li>
              <li className="flex items-start">
                <Clock className="w-5 h-5 mr-3 mt-1 text-[#00C2CB]" />
                <span>Dom - Fest: 9:00 AM - 5:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400 font-quicksand">
            © 2007-{new Date().getFullYear()} Diversytoys. Todos los derechos reservados.
          </p>
          <p>
            Hecho con amor por <a href='https://www.colombiaws.com' target='_blank'>ColombiaWS</a>
          </p>
        </div>
      </div>
    </footer>
  );
};